import { ClubState } from "../../types";
import {
  CREATE_CLUB_SUCCESS,
  DELETE_CLUB_SUCCESS,
  EDIT_CLUB_SUCCESS,
  FETCH_ALL_CLUBS_SUCCESS,
  LOGOUT_USER_REQUEST
} from "../constants";

const initialState: ClubState = {
  clubs: [],
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case CREATE_CLUB_SUCCESS:
      return {
        ...state,
        clubs: [...state.clubs, action.payload.newClub],
      };
    case FETCH_ALL_CLUBS_SUCCESS:
      return {
        ...state,
        clubs: action.payload.allClubs,
      };
    case EDIT_CLUB_SUCCESS:
      return {
        ...state,
        clubs: action.payload.allClubs,
      };
    case DELETE_CLUB_SUCCESS:
      return {
        ...state,
        clubs: action.payload.allClubs,
      };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
